function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 42 42"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#E52F00",
  width: "42",
  height: "42",
  rx: "4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2 7.441h19.537c.456 0 .826.37.826.826v25.62c0 .456-.37.826-.826.826h-19.39a.826.826 0 01-.847-.826V8.113a.7.7 0 01.7-.672z",
  fill: "#F2F4F5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#969EA2",
  d: "M13.594 14.833H28.42v1.239H13.594zm0 4.319H28.42v1.239H13.594zm0 4.326h12.355v1.239H13.594z"
})));